import React from 'react'
import { Row, Col } from 'antd'
import PropTypes from 'prop-types'
import styles from './instrument-card.module.scss'

const InstrumentCard = ({
  srcImage,
  title,
  description,
  descriptionTextAlign,
  colorTitle,
  shadow,
  isClickeable,
  onClick,
  imageHasPadding
}) => {
  return (
    <Row
      className={styles.container}
      style={{
        boxShadow: shadow && '6px 6px 40px rgba(199, 185, 255, 0.3)',
        cursor: isClickeable ? 'pointer' : 'auto'
      }}
      isclickeable={isClickeable?.toString()}
      onClick={isClickeable ? onClick : null}
    >
      <Col className={styles.image_wrapper}>
        <img
          className={styles.image}
          src={srcImage}
          alt={title}
          style={{ padding: imageHasPadding && '1rem' }}
        />
      </Col>
      <Col className={styles.text_wrapper}>
        <h2
          className={styles.title}
          style={{ color: colorTitle }}
        >
          {title}
        </h2>
        <p
          className={styles.description}
          style={{ color: descriptionTextAlign }}
        >
          {description}
        </p>
      </Col>
    </Row>
  )
}

InstrumentCard.propTypes = {
  colorTitle: PropTypes.string,
  description: PropTypes.string.isRequired,
  descriptionTextAlign: PropTypes.string,
  shadow: PropTypes.bool,
  title: PropTypes.string.isRequired,
  imageHasPadding: PropTypes.bool
}

InstrumentCard.defaultProps = {
  descriptionTextAlign: 'center',
  colorTitle: '#17bebb',
  shadow: true,
  imageHasPadding: false
}

export default InstrumentCard
